import { useCallback } from "react";
import { useTenantStore } from "../stores/tenantStore";

const useCheckModule = () => {
	const moduleList = [
		{
			name: "Core",
			key: "core",
			description:
				"The foundational module that provides baseline functionality across the platform. Always enabled for all tenants.",
		},
		{
			name: "Project Delivered",
			key: "project-delivered",
			description:
				"Plan, track, and manage project delivery with kanban boards, task workflows, and detailed activity logging.",
		},
		{
			name: "Time writing",
			key: "time-writing",
			description:
				"Enable users to log, track, and manage their working hours with full timesheet workflows.",
		},
		{
			name: "Reporting",
			key: "reporting",
			description:
				"Generate, manage, and control access to operational and compliance reports.",
		},
		{
			name: "Lessons learned",
			key: "lessons-learned",
			description:
				"Capture, review, and share key insights and learnings from project execution to improve future performance.",
		},
		// {
		// 	name: "Chemical management",
		// 	key: "chemical-management",
		// 	description:
		// 		"Capture, review, and share key insights and learnings from project execution to improve future performance.",
		// },
	];

	const tenantStore = useTenantStore();
	const currentTenant = tenantStore.getTenant();

	const checkModule = useCallback(
		(moduleKey: string) => {
			if (!currentTenant) {
				console.warn("Current tenant not found, module access denied ⚠️");
				return false;
			}
			if (!currentTenant.subscriptions) {
				console.warn(
					"No subscriptions found in current tenant data, module access denied ⚠️"
				);
				return false;
			}
			return currentTenant.subscriptions.includes(moduleKey);
		},
		[currentTenant]
	);

	return {
		moduleList,
		checkModule,
	};
};

export default useCheckModule;
